import commonStyles from './search.module.css';

import { IconButton, TextField } from '@radix-ui/themes';
import { Cross2Icon, MagnifyingGlassIcon } from '@radix-ui/react-icons';

interface Props {
  value: string;
  setValue: (nextValue: string) => void;
  onSearch: (term: string) => void;
  onClear: () => void;
}

export default function Search({ value, setValue, onSearch, onClear }: Props) {
  return (
    <TextField.Root
      placeholder='Искать в задачах…'
      value={value}
      onChange={e => {
        const newValue = e.target.value;
        setValue(newValue);
        onSearch(newValue);
      }}
    >
      <TextField.Slot>
        <MagnifyingGlassIcon
          height='16'
          width='16'
        />
      </TextField.Slot>
      {value && (
        <TextField.Slot>
          <IconButton
            size='1'
            variant='ghost'
            onClick={onClear}
            className={commonStyles.IconButton}
          >
            <Cross2Icon
              height='14'
              width='14'
            />
          </IconButton>
        </TextField.Slot>
      )}
    </TextField.Root>
  );
}
